'use strict';

function Field(name, config) {
	config = config || {};

	this.name = name;
	this.form = null;
	this.validators = {};
	this.options = {};
	this.label = config.label || null;
	this.label_before = config.label_before || null;
	this.label_before_class = config.label_before_class || null;

	if (config.validators) {
		this.addValidators(config.validators);
	}

	if (config.options) {
		this.addOptions(config.options);
	}

	if (config.fieldData) {
		angular.extend(this, config.fieldData);
	}
}

Field.prototype.addValidators = function(validators) {
	this.validators = angular.merge(this.validators, validators);

	return this;
};
Field.prototype.addValidator = function(name, options) {
	this.validators[name] = options;

	return this;
};
Field.prototype.removeValidator = function(name) {
	delete this.validators[name];

	return this;
};

Field.prototype.addOptions = function(options) {
	this.options = angular.merge(this.options, options);

	return this;
};
Field.prototype.addOption = function(name, options) {
	this.options[name] = options;

	return this;
};
Field.prototype.removeOption = function(name) {
	delete this.options[name];

	return this;
};
Field.prototype.link = function(element) {
	var $q = angular.injector(['ng']).get('$q');

	return $q.when(element);
};

Field.prototype.setForm = function(form) {
	this.form = form;
};


module.exports = Field;